/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';


export default function useExternalUserLoader() {
  const allowedOrigins = ['http://localhost:3000', 'https://qrtiger-app-v2.vercel.app', 'https://qrtiger-app-enterprise-v2.vercel.app', 'https://vcard-app-sigma.vercel.app', 'https://app.qrcode-tiger.com', 'https://vcard-app.qrcode-tiger.com', 'https://enterprise-app.qrcode-tiger.com'];

  useEffect(() => {
    console.log('useExternalUserLoader');
    const handler = (event: MessageEvent) => {
      // ✅ Always validate origin
      if (!allowedOrigins.includes(event.origin)) return;

      if (event.data?.type === 'SET_TOKENS') {
        localStorage.setItem(`token-${process.env.REACT_APP_PUBLIC_URL}`, event.data.access_token);
        localStorage.setItem(`refresh-token-${process.env.REACT_APP_PUBLIC_URL}`, event.data.refresh_token);

        if (typeof window !== 'undefined' && window.parent && window.parent !== window) {
          window.parent.postMessage({ type: 'TOKENS_RECEIVED' }, '*');
        }
        window.location.reload();
      }
      if (event.data?.type === 'SET_PARENT_APP_URL') {
        console.log("we get the parent app url dispatched", event.data);
        localStorage.setItem(`parentAppUrl-${process.env.REACT_APP_PUBLIC_URL}`, event.data.parentAppUrl);
      }
      
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, []);

  return null;
}
